import {useState, useEffect} from "react";
import {ArticleItem} from "components/Article/ArticleItem";
import {DashboardLayout} from "components/Layout";
import {Col, Row} from "react-bootstrap";
import {SearchBox} from "components/Table";
import {useArticlePost, useDeleteArticlePost} from "hooks/SuperAdmin/Article";
import InfiniteScroll from "react-infinite-scroll-component";
import {ModalConfirmation} from "components/Modal";
import {useToast} from "hooks/useToast";
import {convertErrorMessageFormat} from "utils/converter";

const PostListPage = () => {
	const [searchKeyword, setSearchKeyword] = useState("");
	const [dataLimit] = useState(10);
	const [dataPage, setDataPage] = useState(1);
	const {data, setFilter} = useArticlePost();
	const [articles, setArticles] = useState([]);
	const {showToast} = useToast();
	const {mutate: deleteArticle, isLoading: isDeleting} = useDeleteArticlePost();
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [selectedArticle, setSelectedArticle] = useState(null);

	useEffect(() => {
		if (data?.data?.rows) {
			setArticles(prevArticles => [...prevArticles, ...data.data.rows]);
		}
	}, [data]);

	const dataWithIDSerial =
		articles?.map((item, index) => ({
			...item,
			idSerial: (dataPage - 1) * dataLimit + index + 1,
		})) || [];

	const fetchMoreData = () => {
		const nextPage = dataPage + 1;

		setDataPage(nextPage);
		setFilter({page: nextPage, limit: dataLimit, search: searchKeyword});
	};

	const handleOpenDeleteModal = article => () => {
		setSelectedArticle(article);
		setShowDeleteModal(true);
	};

	const handleConfirmDelete = () => {
		if (!selectedArticle?.id) return;

		deleteArticle(
			{id: selectedArticle.id},
			{
				onSuccess: () => {
					showToast("success", "Artikel berhasil dihapus!", 3000);
					// Reset list to avoid duplicated append after invalidation
					setArticles([]);
					setDataPage(1);
					setFilter({page: 1, limit: dataLimit, search: searchKeyword});
					setShowDeleteModal(false);
					setSelectedArticle(null);
				},
				onError: res => {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
					setShowDeleteModal(false);
				},
			},
		);
	};

	return (
		<DashboardLayout>
			<div className="box-white d-flex flex-column p-4">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<h5 className="fw-bold text-black mb-3">Artikel</h5>
					</div>
					<SearchBox
						className="shadow-none"
						onSearch={keyword => {
							setSearchKeyword(keyword);
							setFilter({page: 1, limit: dataLimit, search: keyword});
							setDataPage(1);
							setArticles([]);
						}}
					/>
				</div>

				<InfiniteScroll
					className="article-post-infinite-scroll"
					dataLength={dataWithIDSerial.length}
					endMessage={null}
					hasMore={data?.data?.totalPages > dataPage}
					loader={<h4>Loading more articles...</h4>}
					next={fetchMoreData}>
					<Row className="row-gap-3">
						{dataWithIDSerial.map((item, index) => (
							<Col key={index} md={6}>
								<ArticleItem
									isDeleting={isDeleting}
									item={item}
									onDelete={handleOpenDeleteModal(item)}
								/>
							</Col>
						))}
					</Row>
				</InfiniteScroll>

				<ModalConfirmation
					approveLabel="Ya"
					description="Apakah Anda yakin ingin menghapus artikel?"
					loading={isDeleting}
					rejectLabel="Batal"
					visible={showDeleteModal}
					onApprove={handleConfirmDelete}
					onClose={() => setShowDeleteModal(false)}
					onReject={() => setShowDeleteModal(false)}
				/>
			</div>
		</DashboardLayout>
	);
};

export {PostListPage};
